__turbopack_context__.v({
  "className": "lato_d5681cbd-module__ZoCzQa__className",
});
